import { useState, useCallback } from "react"
import { APIError } from "../../../../../../app/modules/auth"
import { exportLeadListToCSV } from "../../../../../../mogul/core/_requests"
import { PassareFilterObject } from "./PassareFilterList"

export const usePassareExport = () => {
    const [exporting, setExporting] = useState(false)
    const [errorExporting, setErrorExporting] = useState<string | null>(null)

    const onExportLeadListToCSV = useCallback(
        async (filterObject: PassareFilterObject) => {
            setExporting(true)
            setErrorExporting(null)
            try {
                await exportLeadListToCSV({
                    type_of_export: "passare",
                    filter: {
                        passare_organization_unique_ids: filterObject.selectedPassareOrganizationUniqueIds || [],
                        start_unix_ts: filterObject.startingUnixTimestamp || undefined,
                        end_unix_ts: filterObject.endingUnixTimestamp || undefined,
                    },
                })
            } catch (exception) {
                console.error(exception)
                const errorMessage =
                    exception instanceof APIError ? exception.message : 'Failed to export leads';
                setErrorExporting(errorMessage)
            } finally {
                setExporting(false)
            }
        },
        []
    )

    return {
        exporting,
        errorExporting,
        onExportLeadListToCSV
    }
}
